<template>
    <div
        v-if="isActive"
        v-show="adyenData && adyenData.loaded"
        class="klarna-payments-container"
        :class="isBillie ? 'billie-container' : ''"
        id="klarna-payments-container"
    ></div>
</template>

<script src="./klarna.js"></script>
